<template>
  <router-view />
  <div class="sidebar">
    <AdCard
      imageSrc="/images/about-tg.png"
      adText="Need a Professional Website? 🚀 Let Tamba Group Build It for You! Fast, +250789 326 245!"
      adLink="https://tambagroup.xyz/"
    />
  </div><br>
  <a
    href="https://wa.me/250788613968"
    target="_blank"
    rel="noopener noreferrer"
    class="whatsapp-link"
  >
    <img src="images/tspwithus.png" style="padding: 10px;" width="300px"/>
  </a>
</template>
<script>
import AdCard from '@/components/AdCard.vue'

export default {
  components: {
    AdCard
  }
}
</script>
<style scoped>
.sidebar {
  position: fixed;
  bottom: 40px;
  right: 10px;
}
.whatsapp-link {
  position: fixed;
  bottom: 0px;
  right: 0px;
  /* background-color: green; */
  color: white;
  padding: 5px;
  border-radius: 50%;
}

/* Hide on mobile */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
</style>
